// extracted by mini-css-extract-plugin
export default {"wrapper":"DevApp-module__wrapper___2vmfH"};